import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoginService } from '../../login/services/login.service';
import { Router } from '@angular/router';
import { CommonService } from '../../common/services/common.service';
import { environment } from '../../../../environments/environment';
import { Utility } from '../../common/services/utility.service';

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private loginService: LoginService, private commonService: CommonService, private _Route: Router,) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<any> {
    return next.handle(request).pipe(catchError(err => {
      if (request.url && (environment.isDevelopment !== true) && ((request.url.indexOf('login') < 0 && (err.status === 401 || err.status === 0) && window.location.pathname != '/login') || err.status === 401)) {
        let errormessage = (err.error?.message || err.statusText || err.error);
        let transalateerrormessage = this.commonService.translate.instant(errormessage);
        if (Utility.IsStringNotNullOrEmpty(transalateerrormessage)) errormessage = transalateerrormessage;
        this.commonService.errorMessage(errormessage);
        this.loginService.logoutUser();
        this._Route.navigate(['/login']);
      }
      if (request.headers && request.headers.has("showerrormessage") && request.headers.get("showerrormessage") === "1") {
        let errormessage = (err.error?.message || err.statusText || err.error);
        let transalateerrormessage = this.commonService.translate.instant(errormessage === "OK" ? "Alerts." + String(err.status) : errormessage);
        if (Utility.IsStringNotNullOrEmpty(transalateerrormessage)) errormessage = transalateerrormessage;
        this.commonService.errorMessage(errormessage);
      }
      return throwError(err);
    }))
  }
}
